"use client";
import useResponsiveSize from "@/hooks/useResponsiveSize";
import { useAutoTranslate } from "@/lib/i18n/useAutoTranslate";
import { Select, SelectProps } from "antd";
import { SelectFieldProps } from "./types";

const SelectField: React.FC<
  SelectFieldProps & Omit<SelectProps, "size" | "onChange" | "onBlur" | "value">
> = ({
  id,
  label,
  name,
  value,
  disabled,
  onChange,
  onBlur,
  placeholder,
  className = "w-full",
  error,
  errorMessage,
  options = [],
  mode,
  required,
  setFieldTouched,
  touched,
  ...rest
}) => {
  const responsiveSize = useResponsiveSize();
  const status = error ? "error" : undefined;
  const tr = useAutoTranslate();
  const translatedLabel = tr(label);
  const translatedPlaceholder = tr(placeholder);
  const translatedErrorMessage = tr(errorMessage);

  return (
    <div className="">
      {label && (
        <label
          className={`${
            disabled ? "text-[#5B6B79]" : "text-text-primary"
          } font-medium  text-xs md:text-sm`}
        >
          {translatedLabel}
          {required && (
            <span className="text-[#FF1F1F] ml-1" aria-hidden="true">
              *
            </span>
          )}
        </label>
      )}
      <div className="mt-1">
        <Select
          showSearch
          optionFilterProp="label"
          id={id}
          mode={mode}
          value={value === "" ? undefined : value}
          size={responsiveSize}
          placeholder={translatedPlaceholder}
          onChange={onChange}
          onBlur={onBlur}
          disabled={disabled}
          status={status}
          options={options}
          className={className}
          {...rest}
          data-touched={touched ? "true" : "false"}
        />
      </div>

      <div
        className={`text-[10px] text-[#FF1F1F] mt-1 absolute transition-all duration-300 ease-in-out
        ${
          error
            ? "opacity-100 scale-100 translate-y-0"
            : "opacity-0 scale-95 -translate-y-1"
        }`}
      >
        {translatedErrorMessage}
      </div>
    </div>
  );
};

export default SelectField;
